const data = {
  dataPurchaseSecondTitle: [
    {
      title: "Purchase your awesome lessons and find your tutors",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem habitant a tincidunt cras accumsan integer suscipit. Libero accumsan eget aliquet.",
    },
  ],
  dataWillGetSecondTitle: [
    {
      title: "What Will You",
      span: "Get?",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id interdum dui mollis .Suspendisse nulla: ",
    },
  ],
  dataWorksSecondTitle: [
    {
      title: "Here’s how it",
      span: "works",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem habitant a tincidunt cras accumsan integer suscipit. Libero accumsan eget aliquet.",
    },
  ],
  dataEduSecondTitle: [
    {
      title: "Edu Smart it's about mastering a timeless skill",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem habitant a tincidunt cras accumsan integer suscipit. Libero accumsan eget aliquet.",
    },
  ],
  dataGetBoxSecondTitle: [
    {
      title: "Learn more than just a language",
      text: "Over 100,000 students join us monthly",
    },
  ],
  dataGreenList: [
    {
      title: "1-on-1 lessons in more than 150 languages",
      text: "Learn from certified teachers with proven experience certified teachers with proven",
      className: "linkText",
      src: "./img/check.png",
      alt: "check",
    },
    {
      title: "Practice for free with the italki community",
      text: "Develop your language skills by building connections with others certified teachers with proven",
      className: "linkText",
      src: "./img/check.png",
      alt: "check",
    },
    {
      title: "Take learning beyond the classroom",
      text: "Learn from certified teachers with proven experience certified teachers with proven",
      className: "linkText",
      src: "./img/check.png",
      alt: "check",
    },
  ],
  dataOrangList: [
    {
      title: "Find a tutor ",
      text: "Choose your ideal teacher from over 10,000 qualified language tutors.",
      src: "./img/user-icon.png",
      alt: "check",
    },
    {
      title: "Book a lesson ",
      text: "Select a lesson time and add it to their calendar.",
      src: "./img/user-icon.png",
      alt: "check",
    },
    {
      title: "Start learning",
      text: "Simple as that, you’re learning a language.",
      src: "./img/user-icon.png",
      alt: "check",
    },
  ],

  linkFind: [
    { href: "/find", className: "footer-link", text: "English Teachers" },
    { href: "/find", className: "footer-link", text: "Chinese Teachers" },
    { href: "/find", className: "footer-link", text: "French Teachers" },
    { href: "/find", className: "footer-link", text: "Spanish Teachers" },
    { href: "/find", className: "footer-link", text: "Other Teachers" },
  ],
  linkLearn: [
    { href: "#", className: "footer-link", text: "Learn Chinese" },
    { href: "#", className: "footer-link", text: "Learn Englishs" },
    { href: "#", className: "footer-link", text: "Learn Spanis" },
    { href: "#", className: "footer-link", text: "Learn French" },
    { href: "#", className: "footer-link", text: "Learn French" },
    { href: "#", className: "footer-link", text: "Learn More Languages" },
  ],
  linkCompany: [
    { href: "#", className: "footer-link", text: "How it Works" },
    { href: "#", className: "footer-link", text: "Term" },
    { href: "#", className: "footer-link", text: "Privacy Policy" },
  ],
  linkMore: [
    { href: "#", className: "footer-link", text: "Documentation" },
    { href: "#", className: "footer-link", text: "Documentation" },
  ],
};
export default data;
